import { VexFlow } from 'vexflow';
import '@vexflow-fonts/bravura/index.css';

let fontsReady: Promise<void> | null = null;
let metricsApplied = false;

/** Métricas ampliadas para iconos legibles en toolbar y compases. */
export function applyBoomVexMetrics(): void {
  if (metricsApplied) return;
  metricsApplied = true;
  VexFlow.setFonts('Bravura', 'Bravura Text');
  VexFlow.NOTATION_FONT_SCALE = 44;
  VexFlow.STAVE_LINE_DISTANCE = 11;
  VexFlow.STEM_HEIGHT = 40;
  VexFlow.STAVE_LINE_THICKNESS = 1.5;
}

export function ensureBoomVexFonts(): Promise<void> {
  applyBoomVexMetrics();
  if (!fontsReady) {
    fontsReady = VexFlow.loadFonts('Bravura', 'Bravura Text').then(() => {
      applyBoomVexMetrics();
    });
  }
  return fontsReady;
}
